import * as React from 'react';
import { connect } from 'react-redux';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Form extends React.Component {
  static defaultProps = {
    className: '',
    role: 'form',
    noValidate: true
  };
  render() {
    const {
      dispatch,
      csrf,
      id,
      className,
      role,
      onSubmit,
      children,
      noValidate,
      ...extraProps
    } = this.props;
    return /*#__PURE__*/_jsxs("form", {
      id: id,
      className: className,
      role: role,
      onSubmit: onSubmit,
      noValidate: noValidate,
      ...extraProps,
      children: [csrf && csrf.enabled && /*#__PURE__*/_jsx("input", {
        type: "hidden",
        name: "_csrf_token",
        value: csrf.token
      }), children]
    });
  }
}
const FormConnected = connect(state => ({
  csrf: state.csrf
}))(Form);
export default FormConnected;